import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useMemo, memo } from 'react';
import { useTheme } from '@emotion/react';
import useMatchMedia from '@segment/utils/useMatchMedia';
import * as views from './Media.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Media = /*#__PURE__*/memo(function (_ref) {
  var at = _ref.at,
      lessThan = _ref.lessThan,
      greaterThan = _ref.greaterThan,
      greaterThanOrEqual = _ref.greaterThanOrEqual,
      between = _ref.between,
      children = _ref.children;

  var _useTheme = useTheme(),
      breakpoints = _useTheme.breakpoints;

  var breakpointsKeys = Object.keys(breakpoints.values);

  if (greaterThan === breakpointsKeys[breakpointsKeys.length - 1]) {
    throw new Error("There is no breakpoint larger than ".concat(greaterThan));
  }

  var queries = useMemo(function () {
    return {
      at: at ? breakpoints.between(at, views.isNumeric(at) ? at : breakpointsKeys[breakpointsKeys.indexOf(at)], false) : "",
      lessThan: lessThan ? breakpoints.down(lessThan, false) : "",
      greaterThan: greaterThan ? breakpoints.up(views.isNumeric(greaterThan) ? greaterThan : breakpointsKeys[breakpointsKeys.indexOf(greaterThan) + 1], false) : "",
      greaterThanOrEqual: greaterThanOrEqual ? breakpoints.up(greaterThanOrEqual, false) : "",
      between: between ? breakpoints.between.apply(breakpoints, _toConsumableArray(between).concat([false])) : ""
    };
  }, [at, between, breakpoints, breakpointsKeys, greaterThan, greaterThanOrEqual, lessThan]);
  var isAtResolution = useMatchMedia(queries.at, true);
  var isLessThanResolution = useMatchMedia(queries.lessThan, true);
  var isGreaterThanResolution = useMatchMedia(queries.greaterThan, true);
  var isGreaterThanOrEqualResolution = useMatchMedia(queries.greaterThanOrEqual, true);
  var isBetweenResolution = useMatchMedia(queries.between, true);
  return _jsx(views.Wrapper, {
    at: at,
    lessThan: lessThan,
    greaterThan: greaterThan,
    greaterThanOrEqual: greaterThanOrEqual,
    between: between,
    breakpointsKeys: breakpointsKeys,
    "data-testid": "media-wrapper",
    children: (isAtResolution || isLessThanResolution || isGreaterThanResolution || isGreaterThanOrEqualResolution || isBetweenResolution) && children
  });
});